import script from "./EditSupervision.vue?vue&type=script&setup=true&lang=js"
export * from "./EditSupervision.vue?vue&type=script&setup=true&lang=js"

import "./EditSupervision.vue?vue&type=style&index=0&id=0b85add8&lang=scss&scoped=true"

import exportComponent from "D:\\yunchi\\yc\\yc-vue-source\\new-energy\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b85add8"]])

export default __exports__